import KnowBeforeYouGo from './KnowBeforeYouGo';
import * as track from 'lib/gaTracking/bookingDetailsPageEvents';

const KnowBeforeYouGoWithTracking = ({ booking }) => <KnowBeforeYouGo booking={booking} onToggle={track.checkInInstructionsDropdown} />;

export default KnowBeforeYouGoWithTracking;
